export const validateSchema = async (schema, values) =>
  await schema
    .validate(values)
    .then(() => ({}))
    .catch((err) => ({
      [err.path]: err.message
    }));
